import React, { useContext, useEffect, useState } from 'react';
import { AssessmentContext } from '../context/AssessmentContext';
import '../styles/Table.css';

const InvitationsTab = ({ assessmentId }) => {
  const {
    assessment,
    loading,
    saveInvitation,
    invitation,
    selectInvitation,
  } = useContext(AssessmentContext);

  const [email, setEmail] = useState('');
  const [mode, setMode] = useState('list');
  const [name, setName] = useState('');
  const [score, setScore] = useState(0);

  useEffect(() => {
    setMode('list');
  }, [assessment]);

  const handleCancel = () => {
    setMode('list'); 
  }

  const handleNew = () => {
    setName('');
    setEmail('');
    setScore(0);
    selectInvitation(null);
    setMode('edit');
  }

  const handleEditInvitation = async (invitationId) => {
    selectInvitation(invitationId);
    setName(invitation.name);
    setEmail(invitation.email);
    setScore(invitation.score);
    setMode('edit');
  }

  const handleSaveInvitation = async () => {
    invitation.name = name;
    invitation.email = email;
    invitation.score = score;
    await saveInvitation(invitation);
  }

  if (loading) {
    return <div>Cargando datos...</div>;
  }

  return (
    <div>
      {mode === 'list' && (
        <>
          <button onClick={() => handleNew() }>
            <span role="img" aria-label="add">➕</span>
          </button>
          <br/>
          <br/>
        </>
      )}
      {mode === 'edit' && (
        <>
          <button onClick={() => handleCancel() }>
            <span role="img" aria-label="cancel">❌</span>
          </button>
          <br/>
          <br/>
        </>
      )}
      {mode === 'list' && (
        <table>
          <thead>
            <tr>
              <th>Código</th>
              <th>Nombre</th>
              <th>Email</th>
              <th>Puntaje</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {assessment.invitations.map((invitation, index) => (
              <tr key={index}>
                <td>{invitation.id}</td>
                <td>{invitation.name}</td>
                <td>{invitation.email}</td>
                <td>{invitation.score}</td>
                <td>
                  <button onClick={() => handleEditInvitation(invitation.id)}>
                    <span role="img" aria-label="edit">✏️</span>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {mode === 'edit' && (
        <>
          <div>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value) }
              placeholder='Email'
            />
          </div>
          <div>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value) }
              placeholder='Nombre'
            />
          </div>
          <br/>
          <button onClick={() => handleSaveInvitation() }>
            Grabar
          </button>
        </>
      )}
    </div>
  );
};

export default InvitationsTab;
